import React, { Suspense, useState, useEffect } from 'react';
import { Button, Container, Spinner } from 'reactstrap';
import { useParams } from 'react-router-dom';
/* eslint import/no-cycle: [2, { maxDepth: 1 }] */
import CONSTANTS from 'utils/CONSTANTS';
import ViewTable from 'utils/ReactTableCards';
import {
  addPatientAddress,
  deletePatientAddress,
  editPatientAddress,
  getAllPatientAddress,
} from 'utils/API/api';
import AddNewModalWithOutButton from 'components/advisor/add-new-Modal-with-out-button';
import IntlMessages from 'helpers/IntlMessages';
import AlertPopup from 'components/alert-popup';

const PatientAddress = () => {
  const { id: patientId } = useParams();
  const [patientAddressList, setPatientAddressList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [patientAddressData, setPatientAddressData] = useState({});
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const handleDeletePatientAddress = (patientAddressId) => {
    setDeleteId(patientAddressId);
    setIsConfirmationOpen(true);
  };

  const confirmDeletePatientAddress = async () => {
    if (deleteId) {
      const res = await deletePatientAddress(deleteId, patientId);
      if (res !== -1) {
        setRefresh((previous) => !previous);
        setIsConfirmationOpen(false);
      }
    }
  };

  const handleEditPatientAddress = (editValue) => {
    if (editValue) {
      setPatientAddressData({ ...editValue });
      setEditModalOpen(true);
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(false);
      const res = await getAllPatientAddress(patientId);
      if (res !== -1) {
        setPatientAddressList(
          res?.data?.data.map((patientAddressItem, index) => {
            return {
              no: index + 1,
              ...patientAddressItem,
              deleteData: {
                buttonLabel: 'Delete',
                id: patientAddressItem?.id,
                onClick: handleDeletePatientAddress,
              },
              editData: {
                buttonLabel: 'Edit',
                id: {
                  ...patientAddressItem,
                },
                onClick: handleEditPatientAddress,
              },
            };
          })
        );
      }
    })();
  }, [refresh]);

  const prepareFormData = (e) => {
    const payload = {};
    CONSTANTS.RIGHT_SIDEBAR_FIELD.PATIENT_ADDRESS_MODAL.forEach((field) => {
      const tempValue = e.target[field.name].value;
      if (tempValue) {
        payload[field.name] = tempValue;
      }
    });

    if (patientId) {
      payload.patientId = patientId;
    }

    return payload;
  };

  const editPatientAddressHandler = (e) => {
    e.preventDefault();
    (async () => {
      if (patientAddressData?.id) {
        const formData = prepareFormData(e);

        setLoading(true);
        const res = await editPatientAddress(
          patientAddressData?.id,
          patientId,
          formData
        );
        if (res !== -1) {
          setRefresh((previous) => !previous);
          setEditModalOpen(!editModalOpen);
        }
        setLoading(false);
      }
    })();
  };

  const addPatientAddressHandler = (e) => {
    e.preventDefault();
    (async () => {
      const formData = prepareFormData(e);

      setLoading(true);
      const res = await addPatientAddress(formData);
      if (res !== -1) {
        setRefresh((previous) => !previous);
        setModalOpen(!modalOpen);
      }
      setLoading(false);
    })();
  };

  return (
    <Suspense fallback={<div className="loading" />}>
      {!loading ? (
        <>
          <Container
            style={{
              display: 'flex',
              justifyContent: 'end',
              maxWidth: '100%',
              margin: '0px',
              padding: '0',
              marginTop: '-10px',
              marginBottom: '15px',
              marginLeft: '-27px',
            }}
          >
            <Button
              outline
              color="primary"
              className="top-right-button"
              onClick={() => setModalOpen(true)}
            >
              <IntlMessages id={CONSTANTS.TABLE_ID.addPatientAddress} />
            </Button>
          </Container>
          <AddNewModalWithOutButton
            sidebarMenu="PATIENT_ADDRESS_MODAL"
            modalTitle={CONSTANTS.TABLE_ID.addPatientAddress}
            modalOpen={modalOpen}
            toggleModal={() => setModalOpen(!modalOpen)}
            onSubmit={addPatientAddressHandler}
            formData={{}}
          />

          <AddNewModalWithOutButton
            sidebarMenu="PATIENT_ADDRESS_MODAL"
            modalTitle={CONSTANTS.TABLE_ID.editPatientAddress}
            modalOpen={editModalOpen}
            toggleModal={() => setEditModalOpen(!editModalOpen)}
            onSubmit={editPatientAddressHandler}
            formData={patientAddressData}
          />

          <ViewTable
            headers={CONSTANTS.TABLE_HEADER.PATIENT_ADDRESS_LIST}
            items={patientAddressList}
            advisorId={CONSTANTS.TABLE_ID.patientAddress}
            filterParams="addressLine1"
          />

          <AlertPopup
            isOpen={isConfirmationOpen}
            positiveText="Yes"
            negativeText="No"
            warning="Are you sure you want to delete?"
            onNegative={() => {
              setIsConfirmationOpen(false);
              setDeleteId(null);
            }}
            onPositive={confirmDeletePatientAddress}
          />
        </>
      ) : (
        <>
          <Container className="d-flex justify-content-center align-items-center">
            <Spinner
              animation="border"
              className="d-inline-flex m-2 "
              color="$theme-color-yellow-granola"
            />
          </Container>
        </>
      )}
    </Suspense>
  );
};
export default PatientAddress;
